import React from "react";
import useController from "./controller";
import FormCore from "components/Form/Core";


import {
    FormTitle,
    HeroTitle,
    RegisterForgot,
    ForgotLink,
    LoginContainer,
    LoginContent,
    FormText,
    LoginInfoContent,
    InfoTitle,
    InfoSpace,
    FormBorder
} from './styled'

import Button from "components/Form/Button";

import ContainerUnauthenticated from "containers/Unauthenticated";
import { ButtonContainer, UnauthenticatedContainer } from "ui/styled";
import OfficeTabs from "components/OfficeTabs";
import { StyledLink } from "components/TermCheck/styled";

export default function Login() {
    const { t, navigate, loading, formRef, formItems, login, options } = useController()

    return (
        <>
            <ContainerUnauthenticated>
                <LoginContent>
                    <HeroTitle>{t("login_title")}</HeroTitle>
                    <OfficeTabs options={options} />
                    <LoginContainer>
                        <UnauthenticatedContainer>
                            <FormTitle>{t("signin")}</FormTitle>
                            <form onSubmit={event => { event.preventDefault(); login(); }}>
                                <FormCore ref={formRef} formItems={formItems} disabled={loading} nospace />
                                <button type="submit" hidden aria-hidden="true" tabIndex={-1} />
                            </form>
                            <RegisterForgot>
                                <ForgotLink onClick={() => navigate('forgot')}>{t("reset_password")}</ForgotLink>
                            </RegisterForgot>
                            <Button color="blue" loading={loading} nospace onClick={login}>{t("login")}</Button>
                        </UnauthenticatedContainer>
                    </LoginContainer>
                    <ButtonContainer center>
                        <FormText center>{t("welcome")}</FormText>
                    </ButtonContainer>
                    <ButtonContainer center>
                        <InfoSpace>
                            <LoginInfoContent>
                                <InfoTitle>{t("existing_users")}</InfoTitle>
                                <FormBorder />
                                <FormText info>{t("enter_credentials_to_continue")}</FormText>
                            </LoginInfoContent>
                            <LoginInfoContent>
                                <InfoTitle>{t("new_users")}</InfoTitle>
                                <FormBorder />
                                <FormText info>
                                    {t("register_and_gain_access_part1")}
                                    <StyledLink onClick={() => navigate('register')}>
                                        {t("register_link_text")}
                                    </StyledLink>
                                    {t("register_and_gain_access_part2")}
                                </FormText>
                            </LoginInfoContent>
                        </InfoSpace>
                    </ButtonContainer>
                </LoginContent>
            </ContainerUnauthenticated>
        </>
    );
}
